document.addEventListener('DOMContentLoaded', function () {
    let isAutoSelectEnabled = true;

    function updateSwatches() {
        const productFormOptions = document.querySelectorAll('.product-form__option');
        const blockSwatchList = document.querySelector('.block-swatch-list');

        let selectedInputValue = '';
        if (blockSwatchList) {
            const selectedInput = blockSwatchList.querySelector('.block-swatch__radio.product-form__single-selector:checked');
            if (selectedInput) {
                selectedInputValue = selectedInput.value;
            }
        }

        if (selectedInputValue === '2 Peças' || selectedInputValue === '3 Peças (Mais Vendido)' || selectedInputValue === '5 Peças') {
            const secondProductFormOption = document.querySelectorAll('.product-form__option')[1];

            if (secondProductFormOption) {
                const blockSwatches = secondProductFormOption.querySelectorAll('.block-swatch');
                let firstVisibleSwatch = null;

                blockSwatches.forEach(function (swatch) {
                    const inputValue = swatch.querySelector('.block-swatch__radio.product-form__single-selector').value;

                    const slashCount = (inputValue.match(/\//g) || []).length;

                    if (selectedInputValue === '2 Peças' && slashCount !== 1) {
                        swatch.style.visibility = 'hidden';
                        swatch.style.position = 'absolute';
                        swatch.style.pointerEvents = 'none';
                    } else if (selectedInputValue === '3 Peças (Mais Vendido)' && slashCount !== 2) {
                        swatch.style.visibility = 'hidden';
                        swatch.style.position = 'absolute';
                        swatch.style.pointerEvents = 'none';
                    } else if (selectedInputValue === '5 Peças' && slashCount !== 4) {
                        swatch.style.visibility = 'hidden';
                        swatch.style.position = 'absolute';
                        swatch.style.pointerEvents = 'none';
                    } else {
                        swatch.style.visibility = '';
                        swatch.style.position = '';
                        swatch.style.pointerEvents = '';
                        if (!firstVisibleSwatch) {
                            firstVisibleSwatch = swatch;
                        }
                    }
                });

                if (isAutoSelectEnabled && firstVisibleSwatch) {
                    const firstRadio = firstVisibleSwatch.querySelector('.block-swatch__radio.product-form__single-selector');
                    if (firstRadio && !firstRadio.checked) {
                        firstRadio.click();
                    }
                }
            }
        } else {
            const secondProductFormOption = document.querySelectorAll('.product-form__option')[1];
            if (secondProductFormOption) {
                const blockSwatches = secondProductFormOption.querySelectorAll('.block-swatch');
                blockSwatches.forEach(function (swatch) {
                    swatch.style.visibility = '';
                    swatch.style.position = '';
                    swatch.style.pointerEvents = '';
                });
            }
        }

        productFormOptions.forEach(function (productFormOption) {
            const disabledSwatches = productFormOption.querySelectorAll('.block-swatch.block-swatch--disabled');
            disabledSwatches.forEach(function (swatch) {
                swatch.classList.remove('block-swatch--disabled');
                swatch.classList.add('block-swatch');
            });
        });

        // Garantir que o display da product-form__info-list nunca seja "none"
        const infoList = document.querySelector('.product-form__info-list');
        if (infoList) {
            infoList.style.display = ''; // Resetar qualquer display configurado como 'none'
        }
    }

    document.addEventListener('change', function (event) {
        if (event.target.matches('.block-swatch__radio.product-form__single-selector')) {
            const blockSwatchList = document.querySelector('.block-swatch-list');
            if (blockSwatchList && blockSwatchList.contains(event.target)) {
                isAutoSelectEnabled = true;
                updateSwatches();
                isAutoSelectEnabled = false;
            }
        }
    });

    const observer = new MutationObserver(function () {
        updateSwatches();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    isAutoSelectEnabled = false;
    updateSwatches();
});